import Route from "@ember/routing/route";

export default class RemoteHandsOverviewRoute extends Route {
  async model() {
    const { project } = this.modelFor("organization");
    const [remoteHandsRequests, colocationRacks] = await Promise.all([
      project.get("remoteHandsRequest"),
      project.get("colocationRacks"),
    ]);

    return {
      remoteHandsRequests,
      colocationRacks,
    };
  }
}
